import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useEffect } from "react";

import { Container } from "reactstrap";

// core components
import SimpleHeader from "@/components/Headers/SimpleHeader";

import DisplayHistoriesContainer from "./DisplayHistoriesContainer";
import DisplayPendingPagesContainer from "./DisplayPendingPagesContainer";

// actions
import { getSitesByDomain } from "@/services/siteServices/siteActions";

const ManagePublish = () => {
  const dispatch = useAppDispatch();
  const CurrentSite = useAppSelector((state) => state.sites.site);

  // same logic as componentWillUnmount
  useEffect(() => {
    return () => {
      dispatch(getSitesByDomain());
    };
  }, [dispatch]);

  return (
    <>
      <SimpleHeader name="Publish Pages" parentName="Pages" />
      <Container className="mt--4" fluid>
        <DisplayHistoriesContainer />
        <DisplayPendingPagesContainer />
      </Container>
    </>
  );
};

export default ManagePublish;
